/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_KitchenInputs */

const cs_enum_kitchen = /** @type {(inputs: Enum_KitchenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuchyně`)
};

const en_enum_kitchen = /** @type {(inputs: Enum_KitchenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kitchen`)
};

/**
* | output |
* | --- |
* | "Kitchen" |
*
* @param {Enum_KitchenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_kitchen = /** @type {((inputs?: Enum_KitchenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_KitchenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_kitchen(inputs)
	return cs_enum_kitchen(inputs)
});